import React from 'react';
import Alert from '../../../Components/Alert';
import AppDialog from '../../../Components/AppDialog';

const WebDashboardFeedback = ({
  t,
  removeBackgroundDialog,
  removeBackgroundDialogMessage,
  continueRemoveBackground,
  resetRemoveBackgroundDialog,
  showAlert,
  alertType,
  alertPosition,
  alertMessage,
  setShowAlert,
}) => (
  <>
    <AppDialog
      open={removeBackgroundDialog.open}
      type="confirm"
      variant="info"
      icon="alert"
      title={t.removeBackgroundDialogTitle || 'Remove Background Image'}
      message={removeBackgroundDialogMessage}
      confirmText={t.continueReposition || 'Continue'}
      cancelText={t.cancel || 'Cancel'}
      showCancel
      onConfirm={continueRemoveBackground}
      onCancel={resetRemoveBackgroundDialog}
      onClose={resetRemoveBackgroundDialog}
    />

    {showAlert && (
      <Alert
        type={alertType}
        position={alertPosition}
        message={alertMessage}
        open={showAlert}
        close={() => setShowAlert(false)}
      />
    )}
  </>
);

export default WebDashboardFeedback;
